<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <AxBuildContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import AxBuildContent from "~~/codepresso-renewal/content/AxBuildContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "AX Build: AI 업무 자동화 구축 | 코드프레소",
  meta: [
    { name: "description", content: "반복 업무를 AI Agent의 일로 바꿉니다. 현장 진단부터 운영 배포까지, 보고서가 아닌 실제 돌아가는 결과물을 남깁니다." },
    { name: "title", content: "AX Build: AI 업무 자동화 구축 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "AX Build: AI 업무 자동화 구축 | 코드프레소" },
    { property: "og:description", content: "반복 업무를 AI Agent의 일로 바꿉니다. 현장 진단부터 운영 배포까지, 보고서가 아닌 실제 돌아가는 결과물을 남깁니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/ax-build.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
